import type {Role} from '@gauged/gauged-js';
import apiClient from 'api';

export async function roles() {
    return apiClient.get<Role[]>('/roles');
}
